import {
  FilterGroupingEnum,
  UserRoleEnum,
  UserScopeNameEnum,
  useSitesSearchListLazyQuery,
  useUsersSearchListLazyQuery,
} from 'graphql-common';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getSitesLoadOptions as getSitesLoadOptionsFn } from 'utils/fetch/searchLists/sitesSearchList';
import { getUsersLoadOptions as getUsersLoadOptionsFn } from 'utils/fetch/searchLists/usersSearchList';

export default function useSearchListQueries() {
  // Sites
  const [fetchSitesSearchListLazyQuery] = useSitesSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getSitesLoadOptions: GetLoadOptions = () =>
    getSitesLoadOptionsFn(fetchSitesSearchListLazyQuery);

  // Users
  const [fetchUsersSearchListLazyQuery] = useUsersSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getUsersLoadOptions = () =>
    getUsersLoadOptionsFn(
      fetchUsersSearchListLazyQuery,
      { name: UserScopeNameEnum.Active },
      [
        {
          role: {
            grouping: FilterGroupingEnum.Or,
            predicate: { eq: UserRoleEnum.User },
          },
        },
      ],
    );
  const getResponsiblePersonLoadOptions = () =>
    getUsersLoadOptionsFn(fetchUsersSearchListLazyQuery, {
      name: UserScopeNameEnum.Active,
    });

  return {
    getResponsiblePersonLoadOptions,
    getSitesLoadOptions,
    getUsersLoadOptions,
  };
}
